import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

import { CloseButton, ModalContainer } from "./ModalStyles";

interface IModal {
  children?: any;
  onOutsideClick?: () => void;
  zIndex?: any;
}
function Modal(props: IModal) {
  const { children } = props;
  const elRef = useRef(null);
  if (!elRef.current) {
    const div = document.createElement("div");
    elRef.current = div;
  }

  useEffect(() => {
    const modalRoot = document.getElementById("modal");
    modalRoot.appendChild(elRef.current);
    return () => modalRoot.removeChild(elRef.current);
  }, []);

  const outsideClick = () => {
    if (props.onOutsideClick != null) {
      props.onOutsideClick();
    }
  };

  return createPortal(
    <ModalContainer>
      <div onKeyDown={() => {}} role="button" className="children-container">
        <CloseButton>
          <button onClick={outsideClick}>X</button>
        </CloseButton>
        {children}
      </div>
    </ModalContainer>,
    elRef.current
  );
}

export default Modal;
